export const baseApi = 'https://rkwater.com:8443/RkWater/api/';
//export const baseApi = 'http://localhost:8080/api/';



// WEBPACK FOOTER //
// ./src/constants/app.js